export const appName = 'witn'

/**
 * Default byline and JSON-LD author for blog posts. Every post is authored
 * by the same person unless its frontmatter sets an `author` override.
 */
export const siteAuthor = 'George Kats'

/**
 * Canonical public origin for the site. Single source of truth for
 * every absolute URL we emit (sitemap, robots, JSON-LD, `metadataBase`,
 * OG/image URLs, etc.) so a domain change only needs one edit.
 */
export const siteUrl = 'https://www.thewitn.com'

/**
 * Site title used as the default `<title>` on routes that don't set
 * their own. Inner pages use the shorter `%s | {appName}` template in
 * the root layout so titles stay under the ~60 char SERP limit.
 */
export const siteTitle = 'witn - Billing infrastructure for AI agent builders'

/**
 * Short meta-description used on the homepage and as the fallback for
 * pages without a frontmatter `description:` and no extractable body
 * paragraph.
 */
export const siteDescription =
  'Outcome-based billing infrastructure for AI agent builders. Define what a successful outcome looks like, send events and bill only verified results.'

export const docsRoute = '/docs'
export const blogRoute = '/blog'
export const glossaryRoute = '/glossary'
export const docsImageRoute = '/og/docs'
export const blogImageRoute = '/og/blog'

/**
 * Raw-markdown API route prefix for any section. We host a Next.js
 * route handler at `/llms.mdx/<section>/<slug>/content.md` for every
 * section that wants the "Copy as Markdown" button.
 *
 * Pass either a section name (`"docs"`) or a source's `baseUrl`
 * (`"/guides"`) — both work.
 */
export function contentRouteFor(sectionOrBaseUrl: string) {
  const section = sectionOrBaseUrl.replace(/^\/+/, '').split('/')[0]
  return `/llms.mdx/${section}`
}

/** Back-compat alias used by proxy.ts. */
export const docsContentRoute = contentRouteFor('docs')

/** Raw-markdown route prefix for the blog section, used by proxy.ts. */
export const blogContentRoute = contentRouteFor('blog')

/** Raw-markdown route prefix for the glossary section, used by proxy.ts. */
export const glossaryContentRoute = contentRouteFor('glossary')
